import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  CUSTOM_ELEMENTS_SCHEMA,
  ElementRef,
  EventEmitter,
  Output,
  ViewChild,
  inject,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';

import { ScrollLockService } from '@modules/shared/services/scroll-lock.service';

@Component({
  selector: 'mb-header-search-input-field',
  templateUrl: './header-search-input-field.component.html',
  styleUrls: ['./header-search-input-field.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslatePipe],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class HeaderSearchInputFieldComponent implements AfterViewInit {
  private router = inject(Router);
  private route = inject(ActivatedRoute);
  private scrollLockService = inject(ScrollLockService);

  @ViewChild('wbInput') wbInput!: ElementRef;

  @Output() closeSearchInputField = new EventEmitter<void>();

  public inputValue = '';

  constructor() {
    this.scrollLockService.lock();
  }

  ngAfterViewInit() {
    this.focusInput();
  }

  public closeSeachOverlay() {
    this.scrollLockService.unlock();
    this.closeSearchInputField.emit();
  }

  private async focusInput() {
    (await this.wbInput.nativeElement.getInputReference()).focus();
  }

  public setInputValue(event: any) {
    this.inputValue = event.detail.value;
  }

  public clearInputValue(): void {
    this.inputValue = '';
  }

  public goToSearchPage(): void {
    this.closeSeachOverlay();
    this.router.navigate(['search'], {
      queryParams: {
        q: this.inputValue,
      },
      relativeTo: this.route,
    });
  }
}
